import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AuthService} from '../auth/AuthService';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StaffService {

  private httpOptions: any;
  token:any
  constructor(private httpClient: HttpClient,
              private authService: AuthService,
              private router: Router) {
  }




  // getAllPateint(params?:any): Observable<any> {
  //   return this.authService.getP(`${'registration-dev/client/all'}`, params);
  // }

  deleteStaff(params?:any): Observable<any> {
    return this.authService.delete(`${environment.userService}staff`, params);
  }
  getAllStaffs(params?:any): Observable<any> {
    return this.authService.getP(`${environment.userService}staff`, params);
  }
  getStaffDetails(params?:any): Observable<any> {
    return this.authService.getP(`${environment.userService}staff`, params);
  }
  updateProvider(body: any, params?:any): Observable<any> {
    return this.authService.put(`${environment.userService}provider`,body, params);
  }
  staffRegistration(staff?: any): Observable<any> {
    return this.authService.post(`${environment.userService}staff`, staff);
  }
  updateStaff(body: any, params?:any): Observable<any> {
    return this.authService.put(`${environment.userService}staff`,body, params);
  }
  getAllOffice(params?:any): Observable<any> {
    return this.authService.getP(`${environment.patientService}office`, params);
  }
}